import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-10 px-4" data-id="element-83">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-84">
        {/* The Core Problem */}
        <FadeIn data-id="element-85">
          <div className="bg-slate-900/80 border border-red-500/20 rounded-3xl p-6 md:p-8 shadow-xl" data-id="element-86">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-87">
              <span className="text-red-500 mr-2" data-id="element-88">❌</span>
              Te enseñaron el "qué"… pero no el "cuándo" ni el "por qué"
            </h2>
            <div className="space-y-3 text-base md:text-lg text-slate-300" data-id="element-89">
              <p data-id="element-90">Y eso cambia todo.</p>
              <p data-id="element-91">Porque aplicar KinesioTaping no es pegar una cinta.</p>
              <p className="text-white font-semibold text-lg md:text-xl mt-4" data-id="element-92">
                Es tomar decisiones.
              </p>
              <ul className="space-y-2 mt-3 ml-4" data-id="element-93">
                <li className="flex items-center" data-id="element-94">
                  <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-95"></span>{' '}
                  Rápidas
                </li>
                <li className="flex items-center" data-id="element-96">
                  <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-97"></span>{' '}
                  Claras
                </li>
                <li className="flex items-center" data-id="element-98">
                  <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-99"></span>{' '}
                  Con criterio
                </li>
              </ul>
              <p className="mt-4" data-id="element-100">Y cuando eso falta…</p>
              <p className="text-lg md:text-xl text-red-400 font-semibold" data-id="element-101">
                Aparece la duda.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pain Points */}
        <FadeIn data-id="element-102">
          <div className="text-center" data-id="element-103">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-104">
              <span className="text-3xl" data-id="element-105">😰</span> ¿Te suena esto?
            </h2>
            <div className="grid gap-3 max-w-xl mx-auto" data-id="element-106">
              <div className="bg-slate-800 p-4 md:p-5 rounded-2xl border border-slate-700 text-left italic text-slate-300" data-id="element-107">
                "¿Esto está bien indicado?"
              </div>
              <div className="bg-slate-800 p-4 md:p-5 rounded-2xl border border-slate-700 text-left italic text-slate-300" data-id="element-108">
                "¿Estoy usando la técnica correcta?"
              </div>
              <div className="bg-slate-800 p-4 md:p-5 rounded-2xl border border-slate-700 text-left italic text-slate-300" data-id="element-109">
                "¿Qué debería pasar después?"
              </div>
            </div>
          </div>
        </FadeIn>

        {/* The Truth */}
        <FadeIn data-id="element-110">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-cyan-500/20 rounded-3xl p-6 md:p-8 shadow-2xl relative overflow-hidden" data-id="element-111">
            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/5 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-112"></div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 flex items-center" data-id="element-113">
              <span className="text-3xl mr-3" data-id="element-114">🧠</span> La verdad incómoda
            </h2>
            <div className="space-y-4 text-base md:text-lg text-slate-300" data-id="element-115">
              <p data-id="element-116">No es que no sepas.</p>
              <p className="text-lg md:text-xl text-white font-medium" data-id="element-117">
                Es que nadie te enseñó a pensar clínicamente en situaciones
                reales.
              </p>
              <p data-id="element-118">Podés saber 100 técnicas…</p>
              <p data-id="element-119">Pero si no sabés:</p>
              <ul className="space-y-2 ml-4 mt-3" data-id="element-120">
                <li className="flex items-center" data-id="element-121">
                  <span className="w-2 h-2 bg-lime-500 rounded-full mr-3" data-id="element-122"></span>{' '}
                  Cuándo usarlas
                </li>
                <li className="flex items-center" data-id="element-123">
                  <span className="w-2 h-2 bg-lime-500 rounded-full mr-3" data-id="element-124"></span>{' '}
                  Por qué usarlas
                </li>
                <li className="flex items-center" data-id="element-125">
                  <span className="w-2 h-2 bg-lime-500 rounded-full mr-3" data-id="element-126"></span>{' '}
                  Qué esperar después
                </li>
              </ul>
              <p className="text-lg md:text-xl text-red-400 font-semibold mt-6 border-l-4 border-red-500 pl-4 py-2" data-id="element-127">
                No estás trabajando como un profesional.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}